var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.30602 3.7951C1.89799 3.38445 1.89799 2.71865 2.30602 2.30799C2.71405 1.89734 3.37559 1.89734 3.78361 2.30799L8.69398 7.25644C9.10201 7.6671 9.10201 8.3329 8.69398 8.74356L3.78361 13.692C3.37559 14.1027 2.71405 14.1027 2.30602 13.692C1.89799 13.2814 1.89799 12.6156 2.30602 12.2049L6.47759 8L2.30602 3.7951ZM12 2C12.5523 2 13 2.44772 13 3V13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13V3C11 2.44772 11.4477 2 12 2Z",
    fill: "#011235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveForward);
export default __webpack_public_path__ + "static/media/move-forward.a9adc4e17ad450d3349a282332049655.svg";
export { ForwardRef as ReactComponent };